import React, { useState, useEffect } from 'react';
import { useRouterHooks } from '@utils/routerHooks';
import Spinner from '@components/Spinner';
import CourseService from '@services/courseService';

interface TParams {
  courseId?: string;
}

export default function withCourse(WrappedComponent: any) {
  return () => {
    const { match } = useRouterHooks<TParams>();
    const [loading, setLoading] = useState(false);
    const [course, setCourse] = useState<Course>();

    const id = Number(match.params.courseId);

    useEffect(() => {
      if (!id) {
        return;
      }

      if (!loading && (!course || (course && course.id !== Number(match.params.courseId)))) {
        setLoading(true);
        CourseService.getOne(id).then((c: any) => {
          setCourse(c);
          setLoading(false);
        });
      }
    }, [course, id, loading, match.params.courseId]);

    if (!id) {
      return <Spinner />;
    }

    if (loading) {
      return <Spinner />;
    }

    if (!course) {
      return null;
    }

    return <WrappedComponent course={course} />;
  };
}
